import { API } from "./api";

export const money = (v) =>
  `$${Number(v || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const toDate = (d) => new Date(d.length === 10 ? `${d}T12:00:00` : d);
const loc = (lang) => (lang === "es" ? "es-US" : "en-US");

export const fmtDate = (d, lang) =>
  d ? toDate(d).toLocaleDateString(loc(lang), { month: "short", day: "numeric", year: "numeric" }) : "—";
export const fmtDay = (d, lang) =>
  d ? toDate(d).toLocaleDateString(loc(lang), { weekday: "short", month: "short", day: "numeric" }) : "—";
export const fmtDateTime = (d, lang) =>
  d ? new Date(d).toLocaleString(loc(lang), { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" }) : "—";

export const fmtTime = (t) => {
  if (!t) return "";
  const [h, m] = t.split(":").map(Number);
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h >= 12 ? "PM" : "AM"}`;
};

export const dateStr = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const todayStr = () => dateStr(new Date());

export const smsLink = (phone, body) => `sms:${phone || ""}?body=${encodeURIComponent(body || "")}`;
export const mailLink = (email, subject, body) =>
  `mailto:${email || ""}?subject=${encodeURIComponent(subject || "")}&body=${encodeURIComponent(body || "")}`;
export const telLink = (phone) => `tel:${phone || ""}`;
export const mapsLink = (addr) => `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(addr || "")}`;

export const gcalLink = (a) => {
  const d = (a.date || "").replace(/-/g, "");
  const [h, m] = (a.time || "09:00").split(":").map(Number);
  const pad = (n) => String(n).padStart(2, "0");
  const start = `${d}T${pad(h)}${pad(m)}00`;
  const end = `${d}T${pad(Math.min(h + 1, 23))}${pad(m)}00`;
  const q = new URLSearchParams({
    action: "TEMPLATE",
    text: `${a.type} - ${a.customer_name || ""}`,
    dates: `${start}/${end}`,
    details: a.notes || "",
    location: a.address || "",
  });
  return `https://calendar.google.com/calendar/render?${q.toString()}`;
};

export const pdfUrl = (path) => `${API}${path}`;
export const photoUrl = (id) => `${API}/photos/${id}/file`;
export const fullName = (c) => `${c?.first_name || ""} ${c?.last_name || ""}`.trim();
const SRC_ES = { Website: "Sitio Web", Referral: "Referido", Other: "Otro", "Repeat Customer": "Cliente recurrente" };
export const srcLabel = (s, lang) => (lang === "es" ? SRC_ES[s] || s : s);
